<template>
  <div>
    <!--  默认地址 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" width="488px" center>
      <div class="content">
        <div class="address">
          <div class="titleName">
            {{ detail.title }}
          </div>
          <!-- 氏名 -->
          <p>
            <span>{{ $t('message.clanName') }}:</span> <span>{{ detail.name }}</span>
          </p>
          <!-- 公司名 -->
          <p>
            <span>{{ $t('message.company') }}:</span> <span>{{ detail.company }}</span>
          </p>
          <!-- 会社名（ローマ字） -->
          <p>
            <span>会社名（ローマ字）:</span> <span>{{ detail.company_roma }}</span>
          </p>
          <!-- 住所 -->
          <p>
            <span>{{ $t('message.domicile') }}:</span> <span>{{ detail.address }}</span>
          </p>
          <!-- 邮编 -->
          <p>
            <span>{{ $t('message.zip_code') }}:</span> <span>{{ detail.zip }}</span>
          </p>
          <!-- 手机 -->
          <p>
            <span>{{ $t('message.mobile') }}:</span> <span>{{ detail.mobile }}</span>
          </p>
          <!-- 座机 -->
          <p>
            <span>{{ $t('message.tel') }}:</span> <span>{{ detail.tel }}</span>
          </p>
          <!-- 法人番号 -->
          <p>
            <span>{{ $t('message.theNumberOfTheCorporation') }}:</span> <span>{{ detail.corporate_name }}</span>
          </p>
          <!-- リアルタイム口座 -->
          <p>
            <span>リアルタイム口座:</span> <span>{{ detail.account }}</span>
          </p>
          <!-- 標準コード -->
          <p>
            <span>標準コード:</span> <span>{{ detail.standard_code }}</span>
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
    title: { type: String },
  },
  data() {
    return {
      dialogVisible: false,
      chat: "",
    };
  },
  computed: {},
  methods: {

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .address {
    background-color: #f8f8f8;
    margin: 10px;

    min-height: 300px;
    padding: 24px;
    flex-direction: column;
    display: flex;
    justify-content: space-between;

    .titleName {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    p {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        &:last-child {
          width: 50%;
        }
      }
    }
  }
}
</style>
